export default __webpack_public_path__ + "static/media/CyberBot.5db55993.webm";